import { useStaffSession } from '@/auth/react';
import { PageHeader } from '@/components/PageHeader';
import { cardClasses } from '@/components/Card';
import { cn } from '@/lib/cn';

/**
 * Platform administration before the service offers it: an honest page that says who is signed in and what
 * this area will hold, with nothing that could pass for a control. Nothing here calls the backend: there
 * is no platform endpoint to call, and the page invents no data.
 */
export function AdminPage() {
  const session = useStaffSession();
  return (
    <section aria-labelledby="admin-title" className="mx-auto flex max-w-2xl flex-col gap-5">
      <PageHeader
        id="admin-title"
        title="Platform administration"
        subtitle={<>Signed in as {session?.user.displayName}.</>}
      />
      <div
        role="status"
        className={cn(cardClasses(), 'flex flex-col gap-2 border-l-[3px] border-l-primary')}
      >
        <p className="text-base font-bold text-ink">Nothing to manage here yet</p>
        <p className="text-sm text-muted">
          This area will hold the platform&apos;s tenants and brands, their branches and settings,
          staff accounts and roles, QR codes and service locations, menus across branches, and
          platform-wide reports.
        </p>
        <p className="text-sm text-muted">These tools aren&apos;t available yet.</p>
      </div>
    </section>
  );
}
